import { render, staticRenderFns } from "./TasksMadeByUserModal.vue?vue&type=template&id=70cd4468&scoped=true"
import script from "./TasksMadeByUserModal.vue?vue&type=script&lang=js"
export * from "./TasksMadeByUserModal.vue?vue&type=script&lang=js"
import style0 from "./TasksMadeByUserModal.vue?vue&type=style&index=0&id=70cd4468&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd4468",
  null
  
)

export default component.exports